/* eslint-disable no-console */
import { client } from "./supabase";

export const getSaldosIniciales = async (pais) => {
  const { data, error } = await client.from("saldos_iniciales").select("*").eq("pais", pais);
  if (error) throw error;
  return data || [];
};

export const upsertSaldoInicial = async ({ pais, entidad_tipo, entidad_id, monto, moneda, notas }) => {
  const { data, error } = await client
    .from("saldos_iniciales")
    .upsert(
      {
        pais,
        entidad_tipo,
        entidad_id: Number(entidad_id),
        monto: Number(monto) || 0,
        moneda: moneda || "CLP",
        notas: notas || null,
      },
      { onConflict: "pais,entidad_tipo,entidad_id" }
    )
    .select()
    .single();
  if (error) throw error;
  return data;
};
